import { useStore } from '../../hooks/useStore'

export default function ProgressBar() {
  const { progress } = useStore()

  return (
    <div className="w-full h-1 bg-primary-100 dark:bg-primary-800">
      <div
        className="h-full bg-primary-900 dark:bg-white transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin="0"
        aria-valuemax="100"
      />
    </div>
  )
}
